import React, {useState} from "react";
import edit_icon from '../../assets/images/edit_small.svg';
import Form from 'react-bootstrap/Form';
import InfoIconHover from "./InfoIconHover";


const InfoDetail = ({ id, title, default_value, info }) => {
    const [editable, setEditable] = useState(false);

    const edit_detail = () => {
        let infoDetail = document.getElementById(id)
        if (infoDetail) {
            setEditable(true)
            let edit_btn = infoDetail.querySelector(".info-detail-edit-btn")
            edit_btn.style.display = "none"
        }
    }

    return (
        <div id={id} className='flex-row space-between'>
            <div className='flex-column'>
                <div className="flex-row"  style={{gap: "10px"}}>
                    <InfoIconHover content={info} size="m"/>
                    <h3 className="regular light">{title}</h3>
                </div>
                <div id={id + "_content"} className="info-detail-content" style={{paddingLeft: "25px"}}>
                    {
                        !editable ? <span className='font-medium light'>{default_value}</span>
                        :  <Form.Control type="text" defaultValue={default_value} style={{zIndex: "1000"}}/>
                    }
                </div>
            </div>
            <div className="info-detail-edit-btn" role="button" onClick={edit_detail}>
                <img src={edit_icon}/>
            </div>
        </div>
    );
};

export default InfoDetail;